// no flow: too many issues with document.body props possibly being undefined

import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax
import keycode from 'keycode';
import bemify, { toModifiers } from 'bemify-js';
import { connectRouteTo } from 'redux-router-kit';

import { addFromUrl } from '@zapier/url-utils';

import AccessibleElement from 'app/common/components/AccessibleElement';
import KindPropType from 'app/common/KindPropType';
import 'app/common/components/Link.scss';

const bem = bemify('link');

const navigableUrlPredicates = [
  // The order matters.
  url => _.isString(url),
  url => !url.startsWith('mailto'),
];
const isNavigableUrl = url =>
  navigableUrlPredicates.every(predicate => predicate(url));

const Link = createReactClass({
  displayName: 'Link',
  mixins: [PureRenderMixin],

  propTypes: {
    preserveScrollPosition: PropTypes.bool,
    shouldPassCurrentUrl: PropTypes.bool,
    shouldRefreshPage: PropTypes.bool,
    shouldScrollToTop: PropTypes.bool,
    target: PropTypes.string,
    onClick: PropTypes.func,
    onTrack: PropTypes.func,
    trackMessage(props) {
      if (props.trackMessage) {
        if (!_.isString(props.trackMessage)) {
          throw new Error('trackMessage must be a string.');
        }
        if (!props.onTrack) {
          throw new Error(
            'To use trackMessage, you must also provide an onTrack function.'
          );
        }
      }
    },
    trackData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
    isDisabled: PropTypes.bool.isRequired,
    kind: KindPropType,
    anchor: PropTypes.string,
  },

  getDefaultProps: function () {
    return {
      style: {},
      // Tack on from_url with current url.
      shouldPassCurrentUrl: false,
      shouldRefreshPage: false,
      isDisabled: false,
    };
  },

  handlePageScrolling() {
    const { shouldScrollToTop, preserveScrollPosition } = this.props;
    const shouldScroll = shouldScrollToTop || preserveScrollPosition;

    if (!shouldScroll) {
      return;
    }

    const scrollValue = preserveScrollPosition ? document.body.scrollTop : 0;
    requestAnimationFrame(() => {
      document.body.scrollTop = scrollValue;
    });
  },

  onClick: function (event) {
    const {
      target,
      onClick,
      trackMessage,
      trackData,
      onTrack,
      href,
      shouldPassCurrentUrl,
    } = this.props;
    if (onClick) {
      onClick(event);
    }
    if (trackMessage) {
      const data = _.isFunction(trackData) ? trackData(this.props) : trackData;
      onTrack(trackMessage, data);
    }
    // If this link goes to a target, skip frontend routing.
    if (target) {
      return;
    }
    this.handlePageScrolling();
    if (href && isNavigableUrl(href)) {
      this.props.routeTo(this.buildUrl(shouldPassCurrentUrl), {
        event,
        exit: this.props.shouldRefreshPage,
      });
    }
    this.onFinishClick(event);
  },

  onFinishClick(event) {
    if (!event) {
      return;
    }
    const { stopPropagation } = this.props;
    event.preventDefault();
    if (stopPropagation) {
      event.stopPropagation();
    }
  },

  onKeyDown(event) {
    if (
      event.keyCode === keycode('space') ||
      event.keyCode === keycode('enter')
    ) {
      event.preventDefault();
      this.onClick();
    }
  },

  buildUrl(shouldPassCurrentUrl) {
    const { href } = this.props;
    const anchor = this.props.anchor || '';
    return shouldPassCurrentUrl
      ? `${addFromUrl(href, window.location.href)}${anchor}`
      : `${href}${anchor}`;
  },

  render: function () {
    const { props } = this;
    const cursorStyle =
      (props.isDisabled && 'default') || props.style.cursor || 'pointer';
    const style = { ...props.style, cursor: cursorStyle };
    const nonDomProps = [
      'shouldPassCurrentUrl',
      'shouldRefreshPage',
      'shouldScrollToTop',
      'routeTo',
      'preserveScrollPosition',
      'onTrack',
      'trackMessage',
      'trackData',
      'isDisabled',
      'dispatch',
      'kind',
    ];
    const domProps = _.omit(this.props, nonDomProps);
    const className = bem(
      toModifiers(props.kind, {
        disabled: props.isDisabled,
      }),
      props.className
    );
    if (props.onClick && !props.href) {
      return (
        <AccessibleElement
          {...domProps}
          onClick={this.onClick}
          style={style}
          tag="a"
        />
      );
    }
    const onClick = props.isDisabled ? this.onFinishClick : this.onClick;
    const onKeyDown = props.isDisabled ? this.onFinishClick : this.onKeyDown;

    return (
      <a
        {...domProps}
        className={className}
        href={this.buildUrl(props.target)}
        onClick={onClick}
        onKeyDown={onKeyDown}
        style={style}
      >
        {props.children}
      </a>
    );
  },
});

export default connectRouteTo(Link);
